import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Homepage from './pages/homepage';
import PatientDashboard from './pages/patient-dashboard';
import DetailedPatientView from './pages/detailed-patient-view';
import LoginScreen from './pages/login-screen';
import RegistrationScreen from './pages/registration-screen';
import CognitiveGamesSection from './pages/cognitive-games-section';
import ProviderDashboard from './pages/provider-dashboard';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/patient-dashboard" element={<PatientDashboard />} />
        <Route path="/detailed-patient-view" element={<DetailedPatientView />} />
        <Route path="/login-screen" element={<LoginScreen />} />
        <Route path="/registration-screen" element={<RegistrationScreen />} />
        <Route path="/cognitive-games-section" element={<CognitiveGamesSection />} />
        <Route path="/provider-dashboard" element={<ProviderDashboard />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;